/* =========================================================================
   MOOI — theme behaviour. Vanilla, no dependencies.
   ========================================================================= */
(function () {
  'use strict';

  var CFG = window.MOOI || {};
  var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

  function money(cents) {
    var fmt = CFG.moneyFormat || '€{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      var a = (cents / 100).toFixed(2);
      if (key.indexOf('comma') > -1) return a.replace('.', ',');
      if (key.indexOf('no_decimals') > -1) return String(Math.round(cents / 100));
      return a;
    });
  }

  /* --------------------------------------------------------------- toast */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-open');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-open'); }, 2600);
  }

  /* ------------------------------------------------------------- drawers */
  var overlay = document.querySelector('[data-overlay]');
  var lastFocus = null;

  function openDrawer(name) {
    var el = document.querySelector('[data-drawer="' + name + '"]');
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    if (overlay) { overlay.hidden = false; void overlay.offsetWidth; overlay.classList.add('is-open'); }
    document.body.classList.add('is-locked');
    var f = el.querySelector('button, [href], input, select, textarea');
    if (f) f.focus();
    document.querySelectorAll('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }

  function closeAll() {
    document.querySelectorAll('[data-drawer].is-open').forEach(function (el) {
      el.classList.remove('is-open');
      setTimeout(function () { el.hidden = true; }, 280);
    });
    document.querySelectorAll('[data-modal].is-open').forEach(function (m) { m.classList.remove('is-open'); });
    if (overlay) { overlay.classList.remove('is-open'); setTimeout(function () { overlay.hidden = true; }, 280); }
    document.body.classList.remove('is-locked');
    document.querySelectorAll('[data-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener && document.querySelector('[data-drawer="' + opener.getAttribute('data-open') + '"]')) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-open'));
      return;
    }

    var mo = e.target.closest('[data-open-modal]');
    if (mo) {
      e.preventDefault();
      var m = document.querySelector('[data-modal="' + mo.getAttribute('data-open-modal') + '"]');
      if (m) {
        m.classList.add('is-open');
        document.body.classList.add('is-locked');
        var f = m.querySelector('button, [href], input');
        if (f) f.focus();
      }
      return;
    }

    var modal = e.target.closest('[data-modal]');
    if (modal && (e.target.closest('[data-close]') || e.target === modal)) { e.preventDefault(); closeAll(); return; }
    if (e.target.closest('[data-close]') || e.target.closest('[data-overlay]')) { e.preventDefault(); closeAll(); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------------------------------------------------------- cart timer */
  var TKEY = 'mooi:cart-expiry';

  function startTimer() {
    if (!CFG.cartTimerEnabled) return;
    if (!localStorage.getItem(TKEY)) {
      localStorage.setItem(TKEY, String(Date.now() + (CFG.cartTimerMinutes || 10) * 60000));
    }
  }
  function clearTimer() { localStorage.removeItem(TKEY); }

  function renderTimer() {
    var wrap = document.querySelector('[data-cart-timer]');
    if (!wrap) return;
    var expiry = parseInt(localStorage.getItem(TKEY) || '0', 10);
    if (!expiry) { wrap.hidden = true; return; }

    wrap.hidden = false;
    var slot = wrap.querySelector('[data-cart-timer-value]');

    function tick() {
      var diff = expiry - Date.now();
      if (diff <= 0) {
        // Don't park on 00:00 forever - roll a fresh window automatically.
        clearInterval(wrap._i);
        wrap.classList.remove('is-expired');
        clearTimer();
        startTimer();
        renderTimer();
        return;
      }
      var m = Math.floor(diff / 60000);
      var s = Math.floor(diff / 1000) % 60;
      if (slot) slot.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
    clearInterval(wrap._i);
    tick();
    wrap._i = setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------------- cart */
  function refreshCount() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
          el.hidden = cart.item_count === 0;
        });
        if (cart.item_count === 0) clearTimer(); else startTimer();
        return cart;
      });
  }

  // Shopify serves cached pages, so the Liquid-rendered bubble can be stale
  // (or blank) on first paint. Always reconcile against the real cart on load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCount);
  } else {
    refreshCount();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });

  function renderDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return false;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var cur = document.querySelector('[data-cart-contents]');
        if (!fresh || !cur) return false;
        cur.innerHTML = fresh.innerHTML;
        var freshTitle = doc.querySelector('[data-drawer="cart-drawer"] .drawer__title');
        var curTitle = document.querySelector('[data-drawer="cart-drawer"] .drawer__title');
        if (freshTitle && curTitle) curTitle.textContent = freshTitle.textContent;
        renderTimer();
        return true;
      })
      .catch(function () { return false; });
  }

  function changeLine(key, quantity) {
    // optimistic: drop the row immediately so the UI never looks stuck
    var row = document.querySelector('[data-line-remove="' + key + '"]');
    var lineEl = row ? row.closest('.cart-line') : null;
    if (quantity === 0 && lineEl) lineEl.style.display = 'none';

    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return renderDrawer().then(function (rendered) {
          // section render unavailable -> keep the DOM honest by hand
          if (!rendered && lineEl && quantity === 0) lineEl.remove();
          if (!rendered && cart && cart.item_count === 0) window.location.reload();
          return refreshCount();
        });
      })
      .catch(function () {
        if (lineEl) lineEl.style.display = '';
      });
  }

  function addToCart(body, opts) {
    opts = opts || {};
    return fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Error');
        startTimer();
        return Promise.all([refreshCount(), renderDrawer()]).then(function () {
          if (opts.silent) { toast(CFG.strings && CFG.strings.added ? CFG.strings.added : 'Added to cart'); }
          else if (document.querySelector('[data-drawer="cart-drawer"]')) openDrawer('cart-drawer');
          else window.location.href = root() + 'cart';
        });
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-line-remove'), 0); return; }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = step.closest('.qty').querySelector('.qty__input');
      var dir = parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(parseInt(input.min || '0', 10), parseInt(input.value, 10) + dir);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', quick.getAttribute('data-quick-add'));
      fd.append('quantity', '1');
      quick.setAttribute('aria-disabled', 'true');
      addToCart(fd, { silent: true })
        .catch(function (err) { toast(err.message); })
        .finally(function () { quick.removeAttribute('aria-disabled'); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-key]');
    if (input) changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[data-atc]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = btn.getAttribute('data-adding') || 'Adding…'; }

    addToCart(new FormData(form))
      .catch(function (err) {
        var slot = form.querySelector('[data-form-error]');
        if (slot) { slot.textContent = err.message; slot.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
      });
  });

  /* ------------------------------------------------------------ variants */
  /* Scroll a horizontal media rail so the given slide is in view.
     This was called from the thumbnail handler and the variant handler but
     never actually defined, so every thumbnail click threw a ReferenceError
     and the gallery appeared dead. */
  function railTo(slide, instant) {
    if (!slide) return;
    var stage = slide.closest('[data-gallery-main]') || slide.parentElement;
    if (!stage) return;
    // offsetLeft is measured against the nearest positioned ancestor, which is
    // not necessarily the stage - when it wasn't, the old maths produced a bogus
    // offset and the gallery never moved (selecting Onyx kept showing the
    // mother-of-pearl photo). Measuring both rects and adding the current scroll
    // is correct whatever the offsetParent is, and survives slides being hidden
    // by the colour filter.
    var left = stage.scrollLeft + (slide.getBoundingClientRect().left - stage.getBoundingClientRect().left);
    if (typeof stage.scrollTo === 'function') {
      // Variant changes scroll instantly: a smooth scroll is still animating when
      // the gallery's IntersectionObserver runs, and the observer then re-selects
      // whichever slide is still in view, undoing the jump.
      stage.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
    } else {
      stage.scrollLeft = left;
    }
  }

  document.querySelectorAll('[data-product-root]').forEach(function (rootEl) {
    var picker = rootEl.querySelector('[data-variant-picker]');
    var data = rootEl.querySelector('[data-variant-json]');
    if (!data) return;

    var variants = JSON.parse(data.textContent);
    var idField = rootEl.querySelector('[data-variant-id]');
    var priceSlot = rootEl.querySelector('[data-price-slot]');
    var atc = rootEl.querySelector('[data-atc]');
    var stockSlot = rootEl.querySelector('[data-stock-slot]');
    var barVariant = document.querySelector('[data-buybar-variant]');

    function apply(match) {
      if (!match) {
        if (atc) { atc.setAttribute('aria-disabled', 'true'); atc.textContent = atc.getAttribute('data-unavailable') || 'Unavailable'; }
        return;
      }
      if (idField) idField.value = match.id;

      if (priceSlot) {
        var html = '<span class="price__now">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s class="price__was">' + money(match.compare_at_price) + '</s>';
          priceSlot.classList.add('price--on-sale');
        } else {
          priceSlot.classList.remove('price--on-sale');
        }
        priceSlot.innerHTML = html;
      }

      if (atc) {
        if (match.available) {
          atc.removeAttribute('aria-disabled');
          atc.textContent = atc.getAttribute('data-add') || 'Add to cart';
        } else {
          atc.setAttribute('aria-disabled', 'true');
          atc.textContent = atc.getAttribute('data-soldout') || 'Sold out';
        }
      }

      if (stockSlot) {
        var cls = 'stock stock--low', txt = stockSlot.getAttribute('data-in-stock') || 'Low stock — selling fast';
        if (!match.available) { cls = 'stock stock--out'; txt = stockSlot.getAttribute('data-out') || 'Out of stock'; }
        else if (match.inventory_management && match.inventory_quantity > 0 &&
                 match.inventory_quantity <= (stockSlot.getAttribute('data-threshold') || 10)) {
          cls = 'stock stock--low';
          txt = (stockSlot.getAttribute('data-low') || 'Only __N__ left').replace('__N__', match.inventory_quantity);
        }
        stockSlot.innerHTML = '<p class="' + cls + '"><span class="stock__dot"></span>' + txt + '</p>';
      }

      if (barVariant) barVariant.textContent = match.title && match.title !== 'Default Title' ? match.title : money(match.price);

      // filter the gallery down to the chosen colour
      // The colour is taken from the chosen VARIANT's own featured image, not by
      // reading the option label. Option names and values are translated
      // ("Boja" / "Belo zlato" in Serbian) while alt text stays English, so
      // label matching silently did nothing outside English.
      // The variant carries its own colour token (English, locale-independent).
      // Falling back to a DOM lookup is not enough on its own: the quick view
      // renders only ONE image per colour, so the variant's exact featured
      // media is often not in the document and the lookup returns null.
      var picked = match.color || null;
      if (!picked && match.featured_media) {
        var selEl = rootEl.querySelector('[data-media-id="' + match.featured_media.id + '"]');
        if (selEl) picked = selEl.getAttribute('data-media-color') || null;
      }

      // thumbnails carry data-gallery-thumb, slides carry data-media-id
      function mediaKey(el) {
        return el.getAttribute('data-media-id') || el.getAttribute('data-gallery-thumb');
      }

      if (picked !== null) {
        rootEl.querySelectorAll('[data-media-color]').forEach(function (el) {
          var c = el.getAttribute('data-media-color');
          el.hidden = !(!c || c === picked);
        });
      }

      // Colour is not always the only option that changes the picture. Tessa has
      // Stone (Mother of Pearl / Onyx) and both stones are the same colour, so a
      // colour-only filter left two images visible and the gallery just kept
      // showing the first one.
      //
      // Work out which images are "claimed" by a specific variant of this colour.
      // If more than one variant of the colour claims a different image, hide the
      // siblings so only the chosen variant's image remains. Images no variant
      // claims (extra angles, worn shots) are left alone, so a product like Nova
      // keeps its full gallery.
      var claimed = {}, distinct = 0;
      variants.forEach(function (v) {
        if (picked !== null && v.color !== picked) return;
        if (!v.featured_media) return;
        var k = String(v.featured_media.id);
        if (!claimed[k]) { claimed[k] = true; distinct++; }
      });
      if (distinct > 1 && match.featured_media) {
        var keep = String(match.featured_media.id);
        rootEl.querySelectorAll('[data-media-color]').forEach(function (el) {
          var k = mediaKey(el);
          if (k && claimed[k] && k !== keep) el.hidden = true;
        });
      }

      var firstId = null;
      rootEl.querySelectorAll('[data-media-color]').forEach(function (el) {
        if (!el.hidden && el.hasAttribute('data-media-id') && firstId === null) {
          firstId = el.getAttribute('data-media-id');
        }
      });

      // Colour is only ONE option. Tessa also varies by Stone, so jumping to the
      // first image of the colour showed mother-of-pearl while Onyx was selected.
      // The variant's own image wins whenever it is present in the document;
      // the colour's first image stays as the fallback for the quick view,
      // which renders only one image per colour.
      var targetId = firstId;
      if (match.featured_media &&
          rootEl.querySelector('[data-media-id="' + match.featured_media.id + '"]')) {
        targetId = String(match.featured_media.id);
      }

      if (targetId) {
        var target = rootEl.querySelector('[data-media-id="' + targetId + '"]');
        if (target) {
          if (target.hidden) target.hidden = false;
          railTo(target, true);
        }
        rootEl.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-selected', t.getAttribute('data-gallery-thumb') === targetId ? 'true' : 'false');
        });
        rootEl.querySelectorAll('[data-dot]').forEach(function (d) {
          d.classList.toggle('is-active', d.getAttribute('data-dot') === targetId);
        });
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    }

    if (!picker) return;

    picker.addEventListener('change', function () {
      var options = [];
      var seen = {};
      picker.querySelectorAll('[data-option-index]').forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        if (seen[i]) return;
        seen[i] = true;
        var checked = picker.querySelector('input[name="' + input.name + '"]:checked');
        options[i] = checked ? checked.value : null;
        if (checked) {
          var label = picker.querySelector('[data-opt-value="' + i + '"]');
          if (label) label.textContent = checked.value;
        }
      });

      apply(variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      }));
    });
  });

  /* ------------------------------------------------------------- gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var stage = gallery.querySelector('[data-gallery-main]');
    if (!stage) return;

    function select(id) {
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-selected', t.getAttribute('data-gallery-thumb') === id ? 'true' : 'false');
      });
      gallery.querySelectorAll('[data-dot]').forEach(function (d) {
        d.classList.toggle('is-active', d.getAttribute('data-dot') === id);
      });
    }

    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-gallery-thumb');
        var slide = stage.querySelector('[data-media-id="' + id + '"]');
        railTo(slide);
        select(id);
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) select(en.target.getAttribute('data-media-id'));
        });
      }, { root: stage, threshold: 0.6 });
      stage.querySelectorAll('[data-media-id]').forEach(function (s) { io.observe(s); });
    }
  });

  /* ------------------------------------------------------------- buy bar */
  (function () {
    var bar = document.querySelector('[data-buybar]');
    var target = document.querySelector('[data-product-form] [data-atc]');
    if (!bar || !target) return;
    bar.hidden = false;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -60px 0px' }).observe(target);
    }

    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-atc]')) { e.preventDefault(); target.click(); }
    });
  })();

  /* ------------------------------------------------------------ wishlist */
  var WKEY = 'mooi:wishlist';
  function wishlist() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function paintWishlist() {
    var list = wishlist();
    document.querySelectorAll('[data-wishlist]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-wishlist')) > -1 ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wishlist');
    var list = wishlist();
    var i = list.indexOf(id);
    if (i > -1) list.splice(i, 1); else list.push(id);
    localStorage.setItem(WKEY, JSON.stringify(list));
    paintWishlist();
  });
  paintWishlist();

  /* --------------------------------------------------------------- share */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-share');
    var title = btn.getAttribute('data-share-title') || document.title;
    if (navigator.share) navigator.share({ title: title, url: url }).catch(function () {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () {
      toast((CFG.strings && CFG.strings.copied) || 'Link copied');
    });
  });

  /* ----------------------------------------------------------- rail nav */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rail-dir]');
    if (!btn) return;
    var nav = btn.closest('[data-rail-nav]');
    var rail = document.getElementById(nav.getAttribute('data-rail-nav'));
    if (!rail) return;
    rail.scrollBy({ left: parseInt(btn.getAttribute('data-rail-dir'), 10) * rail.clientWidth * 0.85, behavior: 'smooth' });
  });

  /* ------------------------------------------------------------ countdown */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var s = {
      d: el.querySelector('[data-cd="d"]'), h: el.querySelector('[data-cd="h"]'),
      m: el.querySelector('[data-cd="m"]'), sec: el.querySelector('[data-cd="s"]')
    };
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.hidden = true; return; }
      if (s.d) s.d.textContent = pad(Math.floor(diff / 86400000));
      if (s.h) s.h.textContent = pad(Math.floor(diff / 3600000) % 24);
      if (s.m) s.m.textContent = pad(Math.floor(diff / 60000) % 60);
      if (s.sec) s.sec.textContent = pad(Math.floor(diff / 1000) % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ------------------------------------------------------------- startup */
  renderTimer();
})();

/* =========================================================================
   MOOI — desktop image zoom + live product recommendations
   ========================================================================= */
(function () {
  'use strict';

  /* --- calm hover zoom, desktop only ----------------------------------- */
  var fine = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function bindZoom(slide) {
    var img = slide.querySelector('img');
    if (!img) return;

    slide.addEventListener('click', function () {
      if (!fine.matches) return;
      slide.classList.toggle('is-zoomed');
      if (!slide.classList.contains('is-zoomed')) img.style.transformOrigin = 'center center';
    });

    slide.addEventListener('mousemove', function (e) {
      if (!slide.classList.contains('is-zoomed')) return;
      var r = slide.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });

    slide.addEventListener('mouseleave', function () {
      slide.classList.remove('is-zoomed');
      img.style.transformOrigin = 'center center';
    });
  }

  document.querySelectorAll('.pdp__slide').forEach(bindZoom);

  /* --- swap in real recommendations once Shopify can generate them ------ */
  var recs = document.querySelector('[data-recs][data-recs-url]');
  if (recs) {
    var url = recs.getAttribute('data-recs-url');
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.rail');
        var cur = recs.querySelector('.rail');
        if (fresh && cur && fresh.children.length > 0) {
          cur.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () { /* fallback collection stays */ });
  }
})();

/* =========================================================================
   MOOI — reviews: filter, sort, paginate, lightbox
   ========================================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-reviews]').forEach(function (root) {
    var list = root.querySelector('[data-review-list]');
    if (!list) return;

    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 8;
    var all = Array.prototype.slice.call(list.querySelectorAll('[data-review]'));
    var moreBtn = root.querySelector('[data-review-more]');
    var sortSel = root.querySelector('[data-review-sort]');
    var filter = 'all';
    var shown = perPage;

    function current() {
      return all.filter(function (el) {
        return filter === 'all' || el.getAttribute('data-stars') === filter;
      });
    }

    function paint() {
      var items = current();
      all.forEach(function (el) { el.hidden = true; });
      items.slice(0, shown).forEach(function (el) { el.hidden = false; });
      if (moreBtn) moreBtn.hidden = items.length <= shown;
      root.querySelectorAll('[data-filter-star]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-filter-star') === filter ? 'true' : 'false');
      });
    }

    function sortBy(mode) {
      var sorted = all.slice();
      if (mode === 'high') sorted.sort(function (a, b) { return b.dataset.stars - a.dataset.stars; });
      else if (mode === 'low') sorted.sort(function (a, b) { return a.dataset.stars - b.dataset.stars; });
      else if (mode === 'photos') sorted.sort(function (a, b) { return b.dataset.hasPhoto - a.dataset.hasPhoto; });
      else sorted.sort(function (a, b) { return a.dataset.index - b.dataset.index; });
      sorted.forEach(function (el) { list.appendChild(el); });
      all = sorted;
    }

    root.addEventListener('click', function (e) {
      var f = e.target.closest('[data-filter-star]');
      if (f) {
        var val = f.getAttribute('data-filter-star');
        filter = (filter === val && val !== 'all') ? 'all' : val;
        shown = perPage;
        paint();
        return;
      }
      if (e.target.closest('[data-review-more]')) {
        var was = current().slice(0, shown);
        shown += perPage;
        paint();
        var revealed = current().slice(was.length, shown);
        revealed.forEach(function (el) {
          el.classList.add('is-new');
          setTimeout(function () { el.classList.remove('is-new'); }, 600);
        });
        if (revealed[0]) revealed[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        sortBy(sortSel.value);
        shown = perPage;
        paint();
      });
    }

    paint();
  });

  /* --- photo lightbox --------------------------------------------------- */
  function closeBox(box) {
    box.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(function () { box.hidden = true; }, 280);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lightbox]');
    if (trigger) {
      var section = trigger.closest('[data-reviews]');
      var modal = section && section.querySelector('[data-lightbox-modal]');
      if (!modal) return;
      modal.querySelector('[data-lightbox-img]').src = trigger.getAttribute('data-lightbox');
      modal.querySelector('[data-lightbox-a]').textContent = trigger.getAttribute('data-lightbox-author') || '';
      modal.querySelector('[data-lightbox-d]').textContent = trigger.getAttribute('data-lightbox-date') || '';
      modal.querySelector('[data-lightbox-b]').textContent = trigger.getAttribute('data-lightbox-body') || '';
      modal.hidden = false;
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.body.classList.add('is-locked');
      return;
    }

    var box = e.target.closest('[data-lightbox-modal]');
    if (box && (e.target === box || e.target.closest('[data-lightbox-close]'))) closeBox(box);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-lightbox-modal].is-open').forEach(closeBox);
  });
})();

/* =========================================================================
   MOOI — quick view
   ========================================================================= */
(function () {
  'use strict';

  var modal, panel, content;

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'qv-modal';
    modal.setAttribute('data-qv-modal', '');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="qv-modal__panel" data-qv-panel>' +
      '<button class="qv-modal__close header__icon" type="button" data-qv-close aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>' +
      '</button><div data-qv-slot></div></div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('[data-qv-panel]');
    content = modal.querySelector('[data-qv-slot]');
    return modal;
  }

  function open() {
    ensureModal().hidden = false;
    void modal.offsetWidth;
    modal.classList.add('is-open');
    document.body.classList.add('is-locked');
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(function () { modal.hidden = true; if (content) content.innerHTML = ''; }, 280);
  }

  /* re-run variant wiring for freshly injected markup */
  function wireVariants(root) {
    var picker = root.querySelector('[data-variant-picker]');
    var data = root.querySelector('[data-variant-json]');
    if (!data) return;

    var variants = JSON.parse(data.textContent);
    var idField = root.querySelector('[data-variant-id]');
    var priceSlot = root.querySelector('[data-price-slot]');
    var atc = root.querySelector('[data-atc]');
    var stockSlot = root.querySelector('[data-stock-slot]');

    function money(cents) {
      var fmt = (window.MOOI && window.MOOI.moneyFormat) || '€{{amount}}';
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
        var a = (cents / 100).toFixed(2);
        return key.indexOf('comma') > -1 ? a.replace('.', ',') : a;
      });
    }

    if (!picker) return;

    picker.addEventListener('change', function () {
      var options = [], seen = {};
      picker.querySelectorAll('[data-option-index]').forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        if (seen[i]) return;
        seen[i] = true;
        var checked = picker.querySelector('input[name="' + input.name + '"]:checked');
        options[i] = checked ? checked.value : null;
        if (checked) {
          var label = picker.querySelector('[data-opt-value="' + i + '"]');
          if (label) label.textContent = checked.value;
        }
      });

      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
      if (!match) return;

      // --- keep the picture in step with the chosen variant ---------------
      // This block used to sit ABOVE `var match = ...`. Because `var` hoists,
      // `match` was undefined here and `match.color` threw a TypeError, which
      // aborted the whole handler - the quick view kept the previous image and
      // looked "crashed". It must stay after `match` is resolved.
      //
      // The variant's own image wins over a colour match: colour is only one
      // option, so on a product that also varies by Stone or Charm the colour
      // filter alone left the wrong photo showing.
      var pickedColor = match.color || null;
      if (!pickedColor && match.featured_media) {
        var selNode = root.querySelector('[data-media-id="' + match.featured_media.id + '"]');
        if (selNode) pickedColor = selNode.getAttribute('data-media-color') || null;
      }
      var qvImgs = Array.prototype.slice.call(root.querySelectorAll('[data-media-color]'));

      if (!qvImgs.length && pickedColor) {
        var raw = Array.prototype.slice.call(root.querySelectorAll('.qv__media img'));
        var byAlt = raw.filter(function (im) {
          return (im.getAttribute('alt') || '').indexOf(pickedColor) === 0;
        });
        if (byAlt.length) raw.forEach(function (im) { im.hidden = im !== byAlt[0]; });
      }

      if (qvImgs.length) {
        var hero = null;
        if (match.featured_media) {
          hero = qvImgs.filter(function (im) {
            return im.getAttribute('data-media-id') === String(match.featured_media.id);
          })[0] || null;
        }
        if (!hero && pickedColor) {
          hero = qvImgs.filter(function (im) {
            return im.getAttribute('data-media-color') === pickedColor;
          })[0] || null;
        }
        if (!hero) {
          hero = qvImgs.filter(function (im) { return !im.getAttribute('data-media-color'); })[0] || qvImgs[0];
        }
        qvImgs.forEach(function (im) { im.hidden = im !== hero; });
      }

      if (idField) idField.value = match.id;

      if (priceSlot) {
        var html = '<span class="price__now">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s class="price__was">' + money(match.compare_at_price) + '</s>';
          priceSlot.classList.add('price--on-sale');
        } else {
          priceSlot.classList.remove('price--on-sale');
        }
        priceSlot.innerHTML = html;
      }

      if (atc) {
        if (match.available) {
          atc.removeAttribute('aria-disabled');
          atc.textContent = atc.getAttribute('data-add') || 'Add to cart';
        } else {
          atc.setAttribute('aria-disabled', 'true');
          atc.textContent = atc.getAttribute('data-soldout') || 'Sold out';
        }
      }

      if (stockSlot) {
        var cls = 'stock stock--low', txt = stockSlot.getAttribute('data-in-stock') || '';
        if (!match.available) { cls = 'stock stock--out'; txt = stockSlot.getAttribute('data-out') || ''; }
        else if (match.inventory_management && match.inventory_quantity > 0 &&
                 match.inventory_quantity <= (stockSlot.getAttribute('data-threshold') || 10)) {
          cls = 'stock stock--low';
          txt = (stockSlot.getAttribute('data-low') || '').replace('__N__', match.inventory_quantity);
        }
        stockSlot.innerHTML = '<p class="' + cls + '"><span class="stock__dot"></span>' + txt + '</p>';
      }
    });

    // Sync once on open so the popup already shows the pre-selected colour,
    // instead of waiting for the shopper to change the swatch.
    picker.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      e.preventDefault();
      var handle = trigger.getAttribute('data-quick-view');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      ensureModal();
      content.innerHTML = '<div class="empty"><p class="muted">…</p></div>';
      open();

      fetch(root + 'products/' + handle + '?section_id=quick-view')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) { window.location.href = root + 'products/' + handle; return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var qv = doc.querySelector('[data-qv-content]');
          if (!qv) { window.location.href = root + 'products/' + handle; return; }
          content.innerHTML = qv.outerHTML;
          wireVariants(content);
        })
        .catch(function () { window.location.href = root + 'products/' + handle; });
      return;
    }

    if (e.target.closest('[data-qv-close]')) { e.preventDefault(); close(); return; }
    if (modal && e.target === modal) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) close();
  });

  /* close the quick view once its add-to-cart succeeds */
  document.addEventListener('submit', function (e) {
    if (!e.target.closest('[data-qv-slot] [data-product-form]')) return;
    setTimeout(close, 600);
  }, true);
})();

/* =========================================================================
   MOOI v1.7 — localisation, filled wishlist, colour-matched gallery
   ========================================================================= */
(function () {
  'use strict';

  /* --- country / language pickers submit on choice ---------------------- */
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.localize__item');
    if (!item) return;
    e.preventDefault();
    var form = item.closest('form');
    if (!form) return;
    var hidden = form.querySelector('[data-localize-input]');
    if (hidden) hidden.value = item.value;
    form.submit();
  });

  /* --- swap the heart to a filled icon when saved ----------------------- */
  var FILLED = '<svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">' +
    '<path fill="currentColor" d="M10 16.5S3.5 12.6 3.5 8.3A3.3 3.3 0 0 1 10 6.6a3.3 3.3 0 0 1 6.5 1.7c0 4.3-6.5 8.2-6.5 8.2z"/></svg>';
  var OUTLINE = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
    '<path d="M10 16.5S3.5 12.6 3.5 8.3A3.3 3.3 0 0 1 10 6.6a3.3 3.3 0 0 1 6.5 1.7c0 4.3-6.5 8.2-6.5 8.2z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>';

  function paintHearts() {
    var list;
    try { list = JSON.parse(localStorage.getItem('mooi:wishlist') || '[]'); }
    catch (e) { list = []; }
    document.querySelectorAll('[data-wishlist]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wishlist')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.innerHTML = on ? FILLED : OUTLINE;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist]')) setTimeout(paintHearts, 0);
  });
  paintHearts();
  document.addEventListener('mooi:cards-rendered', paintHearts);

  /* --- colour switch keeps you on the same shot ------------------------- */
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var picker = root.querySelector('[data-variant-picker]');
    var stage = root.querySelector('[data-gallery-main]');
    if (!picker || !stage) return;

    function currentIndex() {
      var visible = Array.prototype.filter.call(
        stage.querySelectorAll('[data-color-index]'), function (el) { return !el.hidden; });
      if (!visible.length) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2;
      var best = visible[0], bestGap = Infinity;
      visible.forEach(function (el) {
        var gap = Math.abs((el.offsetLeft + el.offsetWidth / 2) - mid);
        if (gap < bestGap) { bestGap = gap; best = el; }
      });
      return parseInt(best.getAttribute('data-color-index'), 10) || 0;
    }

    picker.addEventListener('change', function () {
      var keep = currentIndex();
      // let the main variant handler finish filtering, then align
      setTimeout(function () {
        var visible = Array.prototype.filter.call(
          stage.querySelectorAll('[data-color-index]'), function (el) { return !el.hidden; });
        if (!visible.length) return;
        var target = visible.find(function (el) {
          return parseInt(el.getAttribute('data-color-index'), 10) === keep;
        }) || visible[0];
        target.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });

        var id = target.getAttribute('data-media-id');
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-selected', t.getAttribute('data-gallery-thumb') === id ? 'true' : 'false');
        });
        root.querySelectorAll('[data-dot]').forEach(function (d) {
          d.classList.toggle('is-active', d.getAttribute('data-dot') === id);
        });
      }, 30);
    }, true);
  });
})();

/* =========================================================================
   MOOI v1.8 — scroll reveal (respects the animation setting)
   ========================================================================= */
(function () {
  'use strict';
  if (!document.body.classList.contains('anim-reveal')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.scheme').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.02 });

  document.querySelectorAll('.scheme').forEach(function (el, i) {
    if (i < 2) { el.classList.add('is-in'); return; }   // never hide above the fold
    io.observe(el);
  });
})();


/* =========================================================================
   MOOI v1.9 - reveal-on-scroll-up header
   ========================================================================= */
(function () {
  'use strict';
  var inner = document.querySelector('.header[data-sticky]');
  if (!inner) return;
  // the wrapper is what actually sticks, so it is what we move
  var header = inner.closest('.shopify-section') || inner;

  var last = window.pageYOffset || 0;
  var ticking = false;
  var DOWN_AFTER = 8;
  var UP_AFTER = 6;
  var FREE_ZONE = 120;

  function update() {
    ticking = false;
    var y = window.pageYOffset || 0;
    if (y < 0) y = 0;
    var delta = y - last;

    if (document.body.classList.contains('is-locked')) { last = y; return; }

    if (y <= FREE_ZONE) {
      header.classList.remove('header--tucked', 'header--peek');
      last = y;
      return;
    }
    if (delta > DOWN_AFTER) {
      header.classList.add('header--tucked');
      header.classList.remove('header--peek');
      last = y;
    } else if (delta < -UP_AFTER) {
      header.classList.remove('header--tucked');
      header.classList.add('header--peek');
      last = y;
    }
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]') || e.target.closest('[data-overlay]')) {
      header.classList.remove('header--tucked');
    }
  });
})();


/* =========================================================================
   MOOI v1.11.4 - mobile image zoom
   Tapping the main product image opens a full-screen viewer that can be
   pinch-zoomed and panned. Mobile only: desktop already has hover zoom.
   The overlay is appended to <body>, never inside a section, so no ancestor
   can trap it in a stacking context (see the header/drawer z-index note).
   ========================================================================= */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 989px)');
  var box, imgEl, capEl;

  function build() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'zoomer';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<button class="zoomer__close" type="button" aria-label="Close">' +
        '<svg width="22" height="22" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
        '<path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<div class="zoomer__stage"><img alt=""></div>' +
      '<p class="zoomer__hint"></p>';
    document.body.appendChild(box);
    imgEl = box.querySelector('img');
    capEl = box.querySelector('.zoomer__hint');
    box.addEventListener('click', function (e) {
      if (e.target.closest('.zoomer__close') || e.target === box ||
          e.target.classList.contains('zoomer__stage')) close();
    });
    return box;
  }

  function open(src, alt, hint) {
    build();
    imgEl.src = src;
    imgEl.alt = alt || '';
    capEl.textContent = hint || '';
    box.hidden = false;
    box.offsetWidth;
    box.classList.add('is-open');
    document.body.classList.add('is-locked');
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(function () {
      box.hidden = true;
      imgEl.removeAttribute('src');
      box.querySelector('.zoomer__stage').scrollTo(0, 0);
    }, 240);
  }

  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var slide = e.target.closest('.pdp__slide');
    if (!slide) return;
    var img = slide.querySelector('img');
    if (!img) return;
    e.preventDefault();
    var stage = slide.closest('[data-gallery-main]');
    var total = stage ? stage.querySelectorAll('.pdp__slide:not([hidden])').length : 0;
    var idx = 0;
    if (stage) {
      var vis = Array.prototype.filter.call(stage.querySelectorAll('.pdp__slide'),
        function (el) { return !el.hidden; });
      idx = vis.indexOf(slide) + 1;
    }
    open(img.currentSrc || img.src, img.alt, total > 1 ? idx + ' / ' + total : '');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box && box.classList.contains('is-open')) close();
  });
})();
